import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

function ForecastLegend(props) {
  const { t } = useTranslation('translation', { keyPrefix: 'forecastLegend' });
  // slightly different legends depending on the window size
  const [windowWidth, setWindowWidth] = useState(0);
  const updateDimensions = () => {
    const windowWidth = window.innerWidth;
    setWindowWidth(windowWidth);
  };
  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  if (windowWidth > 1600) {
    return (
      <div className="card-footer">
        <div style={{ fontSize: "0.85rem" }}>
          <ul className="d-flex align-items-center justify-content-end">
            <li
              style={{ height: "2px", width: "25px", background: "black" }}
              className="mr-2"
            ></li>
            <li className="mr-2 pr-2 border-right">{t('current')}</li>
            <li className="mr-2">{t('deviation')}</li>
            <li
              style={{ height: "8px", width: "4px", background: "#328fa8" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#32a0a4" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#33b1a0" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#33c29c" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#34D399" }}
              className="mr-2"
            ></li>
            <li className="mr-2" style={{ minWidth: "36px" }}>
              &lt;5%
            </li>
            <li
              style={{ height: "8px", width: "20px", background: "#f5d742" }}
              className="mr-2"
            ></li>
            <li className="mr-2" style={{ minWidth: "50px" }}>
              5-12%
            </li>
            <li
              style={{ height: "8px", width: "4px", background: "#FF9800" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#fc820b" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#fa6c16" }}
            ></li>
            <li
              style={{ height: "8px", width: "4px", background: "#f85621" }}
            ></li>
            <li
              style={{ height: "8px", width: "6px", background: "#f6412d" }}
              className="mr-2"
            ></li>
            <li style={{ minWidth: "46px" }}>&gt; 12%</li>
          </ul>
        </div>
      </div>
    );
  } else if (windowWidth > 400) {
    return (
      <div className="card-footer">
        <div style={{ fontSize: "0.85rem" }}>
          <ul className="d-flex align-items-center pb-2 border-bottom mb-2">
            <li
              style={{ height: "2px", width: "12px", background: "black" }}
              className="mr-2"
            ></li>
            <li>{t('current')}</li>
          </ul>
          <div className="d-flex align-items-center justify-content-front">
            <ul className="d-flex align-items-center">
              <li className="mr-4">{t('deviation')}</li>
            </ul>
            <ul className="d-flex align-items-center">
              <li
                style={{ height: "8px", width: "12px", background: "#34D399" }}
                className="mr-2"
              ></li>
              <li className="mr-4" style={{ minWidth: "36px" }}>
                &lt; 5%
              </li>
              <li
                style={{ height: "8px", width: "12px", background: "#FF9800" }}
                className="mr-2"
              ></li>
              <li className="mr-4" style={{ minWidth: "50px" }}>
                5 - 12%
              </li>
              <li
                style={{ height: "8px", width: "12px", background: "#F6412D" }}
                className="mr-2"
              ></li>
              <li style={{ minWidth: "46px" }}>&gt; 12%</li>
            </ul>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="card-footer">
        <div style={{ fontSize: "0.85rem" }}>
          <ul className="d-flex align-items-center pb-2 border-bottom mb-2">
            <li
              style={{ height: "2px", width: "12px", background: "black" }}
              className="mr-2"
            ></li>
            <li>{t('current')}</li>
          </ul>
          <ul className="d-flex align-items-center">
            <li className="mr-1">{t('deviation')}</li>
          </ul>
          <div className="d-flex align-items-center justify-content-front">
            <ul className="d-flex align-items-center">
              <li
                style={{ height: "8px", width: "12px", background: "#34D399" }}
                className="mr-2"
              ></li>
              <li className="mr-1" style={{ minWidth: "36px" }}>
                &lt; 5%
              </li>
              <li
                style={{ height: "8px", width: "12px", background: "#FF9800" }}
                className="mr-2"
              ></li>
              <li className="mr-1" style={{ minWidth: "50px" }}>
                5 - 12%
              </li>
              <li
                style={{ height: "8px", width: "12px", background: "#F6412D" }}
                className="mr-2"
              ></li>
              <li style={{ minWidth: "46px" }}>&gt; 12%</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default ForecastLegend;